import React, { createContext, useState, useEffect } from 'react';
import { supabase } from './services/supabaseClient';
import { useFetchCoachByEmailQuery } from './store';

// Resuelve el coach a partir del email del usuario de Supabase (login magic link).
// Requisito: sólo hay acceso si existe un coach con ese email.
export const CoachContext = createContext();

export const CoachProvider = ({ children }) => {
  const [email, setEmail] = useState(null);

  useEffect(() => {
    let mounted = true;
    const apply = (session) => {
      if (mounted) setEmail(session?.user?.email ?? null);
    };
    supabase.auth.getSession().then(({ data }) => apply(data?.session));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) =>
      apply(session)
    );
    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe();
    };
  }, []);

  const { data: coachData, error, isLoading, isFetching } = useFetchCoachByEmailQuery(
    email,
    { skip: !email }
  );

  const coach = coachData?.[0] || null;

  return (
    <CoachContext.Provider value={{ coach, error, isLoading: isLoading || isFetching }}>
      {children}
    </CoachContext.Provider>
  );
};
